import styles from './index.module.less';

const AutoColumns = props => {
    const {
        children,
        cols,
        gridGap = 16,
        forceGrid,
        height = 'auto',
        width = 'auto'
    } = props;
    const split = Math.round(children.length / cols);
    // If there are more than a certain number of fields,
    // push to multiple columns
    const grid = forceGrid || (children.length > cols * 3 && cols > 1);
    // and specify a grid
    const gridStyle = {
        gridTemplateRows: `repeat(${split}, ${height})`,
        gridTemplateColumns: `repeat(${cols}, ${width})`,
        gridGap
    };
    const style = grid ? gridStyle : null;
    return (
        <div
            data-grid={grid}
            className={styles[grid ? 'grid-container' : 'container']}
            style={style}
        >
            {children}
        </div>
    );
};

export default AutoColumns;
